import { resizeManager } from './resizeManager'

class HeaderDropdown {
  private dropdown: HTMLElement | null = null
  private menuItems: NodeListOf<HTMLAnchorElement> | null = null
  private hideTimeout: number | null = null
  private clearTimeout: number | null = null
  private currentDescription: string = ''
  private unsubscribe: (() => void) | null = null

  constructor() {
    this.init()
  }

  private init(): void {
    this.dropdown = document.querySelector('[data-dropdown-content]')
    this.menuItems = document.querySelectorAll('.header-menu a[data-has-dropdown]')

    if (!this.dropdown || !this.menuItems?.length) {
      return
    }

    this.setupEventListeners()

    this.unsubscribe = resizeManager.subscribe('header-dropdown', (isSmall) => {
      if (isSmall) {this.hideDropdown()}
    })
  }

  private setupEventListeners(): void {
    if (!this.menuItems) {
      return
    }

    this.menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => this.handleMouseEnter(item))
      item.addEventListener('mouseleave', () => this.handleMouseLeave())
      item.addEventListener('focus', () => this.handleMouseEnter(item))
      item.addEventListener('blur', () => this.handleMouseLeave())
    })
  }

  private handleMouseEnter(item: HTMLAnchorElement): void {
    this.cancelHide()

    const description = item.dataset.categoryDescription

    if (!description || !this.dropdown) {
      return
    }

    if (this.currentDescription === description && this.dropdown.classList.contains('active')) {
      return
    }

    const wasActive = this.dropdown.classList.contains('active')

    this.currentDescription = description
    this.populateDropdown(description)

    if (wasActive) {
      this.updateHeight()
    } else {
      this.showDropdown()
    }
  }

  private handleMouseLeave(): void {
    this.hideTimeout = window.setTimeout(() => {
      this.hideDropdown()
    }, 150)
  }

  private cancelHide(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout)
      this.clearTimeout = null
    }
  }

  private populateDropdown(description: string): void {
    if (!this.dropdown) {
      return
    }

    this.dropdown.innerHTML = `
      <div>
        <p>${description}</p>
      </div>
    `
  }

  private showDropdown(): void {
    if (!this.dropdown) {
      return
    }

    this.dropdown.classList.add('active')

    requestAnimationFrame(() => {
      if (!this.dropdown) {
        return
      }
      this.dropdown.style.maxHeight = this.dropdown.scrollHeight + 'px'
    })
  }

  private updateHeight(): void {
    if (!this.dropdown) {
      return
    }

    this.dropdown.style.maxHeight = this.dropdown.scrollHeight + 'px'
  }

  private hideDropdown(): void {
    if (!this.dropdown) {
      return
    }

    this.dropdown.style.maxHeight = '0px'
    this.dropdown.classList.remove('active')
    this.currentDescription = ''

    this.clearTimeout = window.setTimeout(() => {
      if (this.dropdown && !this.dropdown.classList.contains('active')) {
        this.dropdown.innerHTML = ''
      }
    }, 250)
  }
  public destroy(): void {
    this.unsubscribe?.()
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeaderDropdown())
} else {
  new HeaderDropdown()
}

export default HeaderDropdown
